export default __webpack_public_path__ + "static/media/apple.31c83ffa.svg";